import { Link } from 'react-router-dom';
import { news } from '@/mocks/news';

type NewsListProps = {
  limit?: number;
};

export default function NewsList({ limit = 6 }: NewsListProps) {
  const items = news.slice(0, limit);

  return (
    <div className="divide-y divide-background-300/70 overflow-hidden rounded-lg border border-background-300/70 bg-background-100">
      {items.map((item) => {
        const date = new Date(item.date);
        return (
          <Link
            key={item.id}
            to={`/detail/${item.relatedFilmId}`}
            className="group flex cursor-pointer items-start gap-4 p-4 transition-colors hover:bg-background-200/60 md:p-5"
          >
            <div className="hidden w-12 shrink-0 flex-col items-center border-r border-background-300/70 pr-4 sm:flex">
              <span className="font-heading text-lg font-semibold leading-none text-foreground-800">
                {String(date.getDate()).padStart(2, '0')}
              </span>
              <span className="mt-1.5 font-label text-[10px] tracking-wider text-foreground-500">
                {date.getFullYear()}.{String(date.getMonth() + 1).padStart(2, '0')}
              </span>
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <span className="rounded bg-accent-500/12 px-1.5 py-0.5 font-label text-[10px] tracking-wider text-accent-400">
                  {item.tag}
                </span>
                <span className="text-[10px] text-foreground-500 sm:hidden">{item.date}</span>
              </div>
              <h3 className="mt-2 text-[14px] font-medium leading-6 text-foreground-900 transition-colors group-hover:text-primary-400">
                {item.title}
              </h3>
              <p className="mt-1.5 line-clamp-2 text-[12px] leading-6 text-foreground-500">{item.summary}</p>
            </div>
            <div className="hidden h-[68px] w-[104px] shrink-0 overflow-hidden rounded-md border border-background-300/60 bg-background-200 md:block">
              <img
                src={item.image}
                alt={`${item.title} 资讯配图`}
                title={`${item.title} · 影视资讯`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
          </Link>
        );
      })}
    </div>
  );
}